<template>
  <main
    ref="CategorySectionWrapper"
    class="absolute inset-0 flex-c"
  >
    <Transition name="fade">
      <Header
        v-show="$route.params.category_id !== 'home'"
        class="absolute top-0 inset-x-0 z-10"
      />
    </Transition>

    <Transition :name="transition">
      <RouterView
        :key="$route.path"
        :category="category"
      />
    </Transition>

    <!-- <Transition name="fade">
      <RouterLink
        v-show="$route.params.category_id === 'find-out-more'"
        :to="pager.prev.slug"
        class="absolute top-2 pin-c-x text-lg md:text-3xl font-sharp uppercase leading-none focus-a z-100"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32" v-bind:svg-inline="''" v-bind:class="'h-4 w-4 md:h-6 md:w-6 mx-auto rotate-180 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 0h56.004L27.896 32z"/></svg>
        <span>Prev</span>
      </RouterLink>
    </Transition> -->

    <Transition name="fade">
      <button
        v-show="pager.currentIndex !== 0 && pager.currentIndex !== categories.length - 1"
        class="absolute bottom-1 pin-c-x text-lg md:text-3xl font-sharp uppercase leading-none focus-a"
        @click="pushRoute(pager.next.slug)"
      >
        <span>Next</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32" v-bind:svg-inline="''" v-bind:class="'h-4 w-4 md:h-6 md:w-6 mx-auto fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M0 0h56.004L27.896 32z"/></svg>
      </button>
    </Transition>

    <Transition name="fade">
      <FpNavDotsSection
        v-show="pager.currentIndex !== 0"
        :categories="categories"
        class="fixed left-0 md:left-6 pin-c-y mobile-landscape:mt-4"
      />
    </Transition>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FpNavDotsSection from '@/components/FpNavDotsSection.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'Categories',

  components: {
    FpNavDotsSection,
    Header
  },

  data: () => ({
    transition: 'slideDown',
    throttle: false,
    // Nasty - If the cta section is scrollable
    // A check for second attempt at scrolling to top to leave
    // Prevents anoyingly be moved from the section if not intented
    scrollTop: false
  }),

  computed: {
    ...mapState([ 'touch', 'mobile', 'slug', 'isNavigation' ]),
    ...mapGetters([ 'getCategoryBySlug', 'subjects', 'categories' ]),

    category() {
      return this.getCategoryBySlug(this.$route.params.category_id)
    },

    pager() {
      const categories = this.categories

      const categoriesLength = categories.length

      const categorySlugs = categories.map(({ slug }) => slug)

      const currentCategory = this.$route.params.category_id

      const currentIndex = categorySlugs.indexOf(currentCategory)

      const prev = currentIndex > 0 ? categories[currentIndex - 1] : categories[0]

      const next = currentIndex < categoriesLength - 1 ? categories[currentIndex + 1] : categories[categoriesLength - 1]

      return { prev, next, currentIndex, currentCategory, categorySlugs }
    },
    listenersTarget() {
      return this.$refs.CategorySectionWrapper
    }
  },

  beforeRouteUpdate(to, from, next) {
    const toIndex = this.pager.categorySlugs.indexOf(to.params.category_id)

    this.transition = toIndex > this.pager.currentIndex ? 'slide-view-up' : 'slide-view-down'

    next()
  },

  created() {
    if (this.isNavigation) {
      this.$store.commit('isNavigation')
    }
  },

  mounted() {
    this.addListeners()
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.handleArrowKeys)
    document.removeEventListener('wheel', this.handleMouseWheel)
  },

  methods: {
    pushRoute(path) {
      if (!this.throttle && !this.isNavigation) {
        this.throttle = true
        this.$router.push({
          name: 'category',
          params: {
            category_id: path
          }
        }).catch(() => console.log())

        setTimeout(() => {
          this.throttle = false
        }, 1400)
      }
    },
    addListeners() {
      window.addEventListener('keyup', this.handleArrowKeys)
      document.addEventListener('wheel', this.handleMouseWheel)

      this.listenersTarget.addEventListener('touchstart', (event) => {
        this.touchstartY = event.changedTouches[0].screenY
      }, false)

      this.listenersTarget.addEventListener('touchend', (event) => {
        this.touchendY = event.changedTouches[0].screenY
        this.handleSwipe()
      }, false)
    },
    handleArrowKeys() {
      switch (event.keyCode) {
      case 38: this.pushRoute(this.pager.prev.slug)
        break
      case 40: this.pushRoute(this.pager.next.slug)
        break
      default:
      }
    },
    handleSwipe() {
      const normalScroll = this.normalScrollCheck(event.target, 'normal-scroll')

      if ((this.touchendY - this.touchstartY) < -20 && !normalScroll) {
        this.pushRoute(this.pager.next.slug)
      }

      if ((this.touchendY - this.touchstartY) > 20 && !normalScroll) {
        this.pushRoute(this.pager.prev.slug)
      }
    },
    handleMouseWheel(e) {
      const delta = Math.sign(e.deltaY)
      const normalScroll = this.normalScrollCheck(event.target, 'normal-scroll')

      if (!normalScroll) {
        delta === 1 ? this.pushRoute(this.pager.next.slug) : this.pushRoute(this.pager.prev.slug)
      }
    },
    // Checks if any parent element has a class and returns that element
    normalScrollCheck(el, classname) {
      if (el.className.split(' ').indexOf(classname) >= 0) return this.normalScrollEndCheck(el, 'scroll-end')

      return el.parentElement && this.normalScrollCheck(el.parentElement, classname)
    },
    // Checks if the normal-scroll element react at element extermes
    normalScrollEndCheck(el, classname) {
      // Can the element scroll
      const isScrollable = el.scrollHeight > el.clientHeight
      console.log(isScrollable)

      if (el.classList.contains(classname)) {
        if (isScrollable) {
          el.onscroll = () => {
            // Scrolled to bottom
            if (el.scrollTop === (el.scrollHeight - el.offsetHeight)) {
              // Do something maybe
              return false
              // Scrolled to top
            } else if (el.scrollTop === 0) {
              if (!this.scrollTop) {
                this.scrollTop = true
              } else {
                this.pushRoute(this.pager.prev.slug)
                this.scrollTop = false
              }
              // This.pushRoute(this.pager.prev.slug)
            }
            return false
          }
        } else {
          // Not scrollable don't worry about it
          return false
        }
      }
      // Just return the no scroll element
      return el
    }
  }
}
</script>
